import React, { useMemo } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import * as BuilderUI from '../../../../../components/Builder/BuilderUI';
import { MAX_TIME_WINDOW } from '../../../../../config/constants';
import { optionsForDays } from '../../../../../components/Builder/BuilderFields/BuilderNumericalMenu/utils';
import BuilderNumericalMenu from '../../../../../components/Builder/BuilderFields/BuilderNumericalMenu';
import { setBuilderTimeWindowAction } from '../../../../../redux/slices/oldBuilder';
import { defaultInputStyles } from '../../../../../components/Form/inputStyles';
import { ITooltipOption } from '../../../../../components/KubitTooltip/globalTooltips';
import KubitTooltip from '../../../../../components/KubitTooltip';

import { builderDateSelector } from '../../../../../redux/selectors/date';

const Wrapper = styled.div`
  ${defaultInputStyles};
  min-width: 60px;
  &:hover {
    cursor: pointer;
  }
`;

const TOOLTIP_DATE_FORMAT = 'MM/DD/YYYY';

const RetentionTimeWindow = () => {
  const dispatch = useAppDispatch();

  const builderDates = useAppSelector(builderDateSelector);
  const timeWindow = useAppSelector(({ builder }) => builder.timeWindow);

  const handleChange = (newValue: number | null) => {
    dispatch(setBuilderTimeWindowAction({ newValue }));
  };

  const tooltipContent: ITooltipOption = useMemo(() => {
    const startDate = moment(builderDates.startDate).format(
      TOOLTIP_DATE_FORMAT,
    );
    // custom end date = end date + currValue
    let end = moment(builderDates.endDate);

    if (Number(timeWindow)) {
      end = end.add(Number(timeWindow), 'days');
    }

    const endDate = end.format(TOOLTIP_DATE_FORMAT);

    return {
      content: `${startDate} - ${endDate}`,
    };
  }, [builderDates, timeWindow]);

  return (
    <BuilderUI.BuilderFieldContainer>
      <KubitTooltip
        content={
          `Look Forward extends the date range to calculate a return event` +
          ` and should be updated when the cohort end date has passed.`
        }
        noOpenDelay={true}
      >
        <BuilderUI.BuilderFieldLabel>
          looking forward
        </BuilderUI.BuilderFieldLabel>
      </KubitTooltip>
      <BuilderNumericalMenu
        trigger={
          <KubitTooltip {...tooltipContent} noOpenDelay={true}>
            <Wrapper>{timeWindow}</Wrapper>
          </KubitTooltip>
        }
        placeholder={'Enter a value'}
        value={timeWindow || null}
        max={MAX_TIME_WINDOW}
        options={optionsForDays}
        onChange={handleChange}
      />
    </BuilderUI.BuilderFieldContainer>
  );
};

export default RetentionTimeWindow;
